import { pipe, uniqBy, filter, toArray } from '@fxts/core';
import { getYear, getMonth } from 'date-fns';
import { isAfterOrSameYearMonth, isBeforeOrSameYearMonth } from './date.mjs';

function getMonthCountInRange(startDate, endDate, excludeDates = []) {
  const startYear = getYear(startDate);
  const startMonthIndex = getMonth(startDate);
  const endYear = getYear(endDate);
  const endMonthIndex = getMonth(endDate);
  const monthCountInRange = (endYear - startYear) * 12 + (endMonthIndex - startMonthIndex) + 1;
  const excludedMonthCount = pipe(
    excludeDates,
    uniqBy((excludeDate) => `${getYear(excludeDate)}-${getMonth(excludeDate)}`),
    filter((excludeDate) => {
      const isAfterOrSameStartMonth = isAfterOrSameYearMonth(
        excludeDate,
        startDate
      );
      const isBeforeOrSameEndMonth = isBeforeOrSameYearMonth(
        excludeDate,
        endDate
      );
      return isAfterOrSameStartMonth && isBeforeOrSameEndMonth;
    }),
    toArray
  ).length;
  return monthCountInRange - excludedMonthCount;
}

export { getMonthCountInRange as default };
//# sourceMappingURL=getMonthCountInRange.mjs.map
